var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frame-wrapper"},[(_vm.isPdfModel && !_vm.isLoaded)?_c('TemplateRender'):(!_vm.isLoaded)?_c('Object3dModel'):(_vm.isLoaded)?_c('div',{staticClass:"loader-wrapper"},[_c('Loader')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }